module.exports = __webpack_public_path__ + "img/logo-white.d41add8c.png";